import './programblock.less'

import {Icon} from '@codeurs/front'
import {SummitsLinkType} from 'pages'
import React from 'react'
import {DOMAttrs, Mod, SummitType, WysiwygType} from 'types'
import {Link} from 'util/link'
import {style} from 'util/style'
import {Summitlogo} from 'views/layout/summitlogo'
import {Theme} from 'views/theme'

const styles = style('programblock', ['time', 'timeline', 'content'])

export const Programblock: React.FC<{
	mod?: Mod<'sub' | 'session' | 'sequence' | 'breakout'>
	has_down?: boolean
} & DOMAttrs> = ({mod, has_down, children}) => {
	return (
		<div
			className={styles()
				.mod(mod)
				.mod({down: has_down})}
		>
			<div className={styles('left')}>{children}</div>
			{has_down && (
				<div className={styles('right')}>
					<div className={styles('right-icon')}>
						<Icon icon="chevron-down-wide" />
					</div>
				</div>
			)}
		</div>
	)
}

export const ProgramblockTime: React.FC<{
	start_time?: string
	end_time?: string
}> = ({start_time, end_time}) => {
	return (
		<div className={styles.time()}>
			{start_time && <p className={styles.time('start')}>{start_time}</p>}
			{end_time && <p className={styles.time('end')}>{end_time}</p>}
		</div>
	)
}

export const ProgramblockTimeline: React.FC<{
	start_time?: string
	mod?: Mod<'sub' | 'session' | 'sequence' | 'breakout'>
}> = ({start_time, mod}) => (
	<div
		className={styles
			.timeline()
			.mod(mod)
			.mod({start: !!start_time})}
	>
		<div className={styles.timeline('circle')} />
		{start_time && <p className={styles.timeline('start')}>{start_time}</p>}
	</div>
)

export const ProgramblockContent: React.FC<{
	title: string
	short_desc?: WysiwygType
	summits?: Array<SummitType>
	mod?: Mod<'start'>
	summits_link?: SummitsLinkType
}> = ({title, short_desc, summits, mod, summits_link}) => {
	if (!title && !short_desc) return null

	return (
		<div className={styles.content.mod(mod)}>
			{title && <Theme.H5>{title}</Theme.H5>}
			{short_desc && <Theme.Wysiwyg>{short_desc}</Theme.Wysiwyg>}
			{summits && summits.length > 0 && (
				<div className={styles.content('summits')}>
					{summits.map((summit, i) => {
						const summitLink =
							summits_link && summits_link.find(item => item?.summit === summit)

						return (
							<Link
								to={summitLink?.link?.url}
								target="_blank"
								className={styles.content('summits-link')}
								key={i}
							>
								<Summitlogo summit={summit} />
							</Link>
						)
					})}
				</div>
			)}
		</div>
	)
}
